import React, { Component } from "react"
import PropTypes from "prop-types"
import Icon from "../../components/icon-v2"
import NavGroup from "./NavGroup"
import Components from "../../components"
import linkHandler from "../../helpers/storyblokLinkHandler"
import { getKey } from "../../helpers/getKey"
import {
  StyledMenu,
  StyledMenuInner,
  StyledHeader,
  StyledLogo,
  StyledTitle,
  StyledClose,
  StyledNav,
  StyledNavItem,
  StyledButton,
  StyledBackground,
  StyledSecondaryTitle,
  StyledNavTitle,
  StyledNavItemChild,
  StyledOtherMenuTitle,
  StyledPageMenuItemGroupContent,
} from "./partials/StyledMenu"

import {
  StyledSubHeader,
  StyledPageNavMenuItemGroupContent,
  StyledMainLink,
  StyledAddOnTracks,
  StyledAddOnTrackLabel,
  StyledDash,
} from "./partials/StyledPageNav"
import ButtonV2 from "../button-v2"
import Link from "./Link"

class Menu extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick() {
    this.props.onClickHandler()
  }
  render() {
    const pageNavExists = this.props.pageNavExists
    return (
      <>
        <StyledMenu isOpen={this.props.isOpen}>
          <StyledMenuInner>
          <StyledHeader pageNavTheme={pageNavExists}>
            <div>
              {this.props.logo && (
                <StyledLogo
                  pageNavTheme={pageNavExists}
                  isOpen={this.props.isOpen}
                >
                  <img alt="Hult Logo" src={this.props.logo} />
                </StyledLogo>
              )}
              {pageNavExists && (
                <>
                  {this.props.pageTitle && this.props.pageTitle.length > 0 && (
                    <StyledTitle isOpen={this.props.isOpen}>
                      {this.props.pageTitle.map((content, idx) => (
                        <Link
                          key={getKey("page-title-", content._uid ? content._uid : idx)}
                          url={content.link}
                          label={content.label}
                          target={content.target}
                        />
                      ))}
                    </StyledTitle>
                  )}
                </>
              )}
            </div>
            <StyledClose
              pageNavTheme={pageNavExists}
              isOpen={this.props.isOpen}
              onClick={this.handleClick}
            >
              <Icon icon="times" iconType="fal" />
            </StyledClose>
          </StyledHeader>

          <StyledNav pageNavTheme={pageNavExists} isOpen={this.props.isOpen}>
            {this.props.pageNav &&
              this.props.pageNav.map((content, idx) => {
                if (content.component === "link_group") {
                  return (
                    <NavGroup
                      pageNavExists={pageNavExists}
                      key={getKey("nav-group-", content._uid ? content._uid : idx)}
                      defaultOpen={content.default_open}
                      title={content.title}
                      isOpen={this.props.isOpen}
                    >
                      {content.links &&
                        content.links.map((contentLink, idx) => {
                          return (
                            <StyledNavItemChild
                              pageNavTheme={pageNavExists}
                              key={getKey("nav-group-", contentLink._uid ? contentLink._uid : idx)}
                              >
                              <StyledPageMenuItemGroupContent dividing_line={contentLink.dividing_line}>
                                  {contentLink.sub_header && <StyledSubHeader>{contentLink.sub_header}</StyledSubHeader>}
                                  {contentLink.label &&
                                    <StyledMainLink>
                                      <Link
                                        pageNavProgram={this.props.pageNavProgram}
                                        url={contentLink.link}
                                        path={this.props.path}
                                        target={contentLink.target}
                                        label={contentLink.label}
                                        icon={contentLink.icon}
                                        />
                                    </StyledMainLink>
                                  }
                                  {contentLink.add_on_tracks && contentLink.add_on_tracks.map((l) => (
                                    <StyledAddOnTracks>
                                      <StyledAddOnTrackLabel>
                                        <Link
                                          pageNavProgram={this.props.pageNavProgram}
                                          key={l._uid}
                                          url={l.link}
                                          path={this.props.path}
                                          target={l.target}
                                          label={l.label}
                                          icon={l.icon}
                                          dash={true}
                                          />
                                      </StyledAddOnTrackLabel>
                                    </StyledAddOnTracks>
                                  ))}
                              </StyledPageMenuItemGroupContent>
                            </StyledNavItemChild>
                          )
                        })}
                    </NavGroup>
                  )
                } else if (content.component === "link") {
                  return (
                    <StyledNavItem
                      onClick={this.handleClick}
                      programStyle={true}
                      pageNavTheme={pageNavExists}
                      key={content._uid}
                      href={linkHandler(content.link)}
                      target={content.target || "_self"}
                    >
                      {content.label}
                    </StyledNavItem>
                  )
                }
              })}

            {this.props.pageButtons && (
              <StyledButton isOpen={this.props.isOpen}>
                {this.props.pageButtons.map((content, idx) =>
                  React.createElement(Components(content.component), {
                    key: getKey("page-buttons-", content._uid ? content._uid : idx),
                    blok: content,
                  })
                )}
              </StyledButton>
            )}
          </StyledNav>

          <StyledNav isOpen={this.props.isOpen}>
            {pageNavExists && (
              <StyledNavItem otherMenuTitle={true} href="#">
                More From Hult
              </StyledNavItem>
            )}
            {this.props.nav &&
              this.props.nav.map((content, idx) => {
                if (content.component === "link_group") {
                  return (
                    <NavGroup
                      key={getKey("nav-group-", content._uid ? content._uid : idx)}
                      defaultOpen={content.default_open}
                      title={content.title}
                      isOpen={this.props.isOpen}
                    >
                      {content.links &&
                        content.links.map((contentLink) => {
                          return (
                            <StyledNavItemChild key={contentLink._uid}>
                              <Link
                                url={contentLink.link}
                                path={this.props.path}
                                target={contentLink.target}
                                label={contentLink.label}
                              />
                            </StyledNavItemChild>
                          )
                        })}
                    </NavGroup>
                  )
                } else if (content.component === "link") {
                  return (
                    <StyledNavItem
                      key={content._uid}
                      href={linkHandler(content.link)}
                      target={content.target || "_self"}
                    >
                      {content.label}
                    </StyledNavItem>
                  )
                } else {
                  return (
                    content.buttons && (
                      <StyledButton isOpen={this.props.isOpen}>
                        {content.buttons.map((contentButton, idx) => 
                          React.createElement(Components(contentButton.component), {
                            key: getKey("buttons-", contentButton._uid ? contentButton._uid : idx),
                            blok: contentButton,
                          })
                        )}
                      </StyledButton>
                    )
                  )
                }
              })}
          </StyledNav>
          </StyledMenuInner>
        </StyledMenu>
        <StyledBackground
          isOpen={this.props.isOpen}
          onClick={this.handleClick}
        />
      </>
    )
  }
}

export default Menu
